module.exports = __webpack_public_path__ + "img/netBack.78409160.png";